import { login, authCallback, phoneLogin } from '@/api/user';
import { getToken, localSave, localRead, getUserInfo } from '@/libs/util';
import { resetRouter } from '@/router';
export const CURRENT_USER_NAME = 'CURRENT_USER_NAME';
export const CURRENT_USER_CODE = 'CURRENT_USER_CODE';
export const CURRENT_USER_ROLE = 'CURRENT_USER_ROLE';
export const CURRENT_USER_ID = 'CURRENT_USER_ID';
export const CURRENT_USER_ORGANIZENAME = 'CURRENT_USER_ORGANIZENAME';
export const CURRENT_USER_MOBILEPHONE = 'CURRENT_USER_MOBILEPHONE';
export const CURRENT_USER_DEPARTMENTID = 'CURRENT_USER_DEPARTMENTID';
export const CURRENT_USER_DEPARTMENTTYPE = 'CURRENT_USER_DEPARTMENTTYPE';
export const CURRENT_USER_DEPARTMENTNAME = 'CURRENT_USER_DEPARTMENTNAME';
export const CURRENT_USER_DEPARTMENTTYPENAME =
  'CURRENT_USER_DEPARTMENTTYPENAME';
export default {
  state: {
    userName: localRead(CURRENT_USER_NAME),
    userCode: localRead(CURRENT_USER_CODE),
    userRole: localRead(CURRENT_USER_ROLE),
    userInfo: getUserInfo(),
    token: getToken(),
    userId: localRead(CURRENT_USER_ID),
    organizename: localRead(CURRENT_USER_ORGANIZENAME),
    mobilephone: localRead(CURRENT_USER_MOBILEPHONE),
    departmentid: localRead(CURRENT_USER_DEPARTMENTID),
    departmentname: localRead(CURRENT_USER_DEPARTMENTNAME),
    departmenttype: localRead(CURRENT_USER_DEPARTMENTTYPE),
    departmenttypename: localRead(CURRENT_USER_DEPARTMENTTYPENAME),
    access: [],
    userInfo: null,
  },
  mutations: {
    setUserInfo(state, id) {
      sessionStorage.setItem('userInfo', id);
    },
    setUserName(state, name) {
      state.userName = name;
      localSave(CURRENT_USER_NAME, name);
    },
    setUserCode(state, code) {
      state.userCode = code;
      localSave(CURRENT_USER_CODE, code);
    },
    setUserRole(state, role) {
      state.userRole = role;
      localSave(CURRENT_USER_ROLE, role);
    },
    setToken(state, token) {
      state.token = token;
      sessionStorage.setItem('token', token);
    },
    setUserId(state, id) {
      state.userId = id;
      localSave(CURRENT_USER_ID, id);
    },
    setOrganizename(state, organizename) {
      state.organizename = organizename;
      localSave(CURRENT_USER_ORGANIZENAME, organizename);
    },
    setMobilephone(state, mobilephone) {
      state.mobilephone = mobilephone;
      localSave(CURRENT_USER_MOBILEPHONE, mobilephone);
    },
    setDepartmentid(state, departmentid) {
      state.departmentid = departmentid;
      localSave(CURRENT_USER_DEPARTMENTID, departmentid);
    },
    setDepartmentname(state, departmentname) {
      state.departmentname = departmentname;
      localSave(CURRENT_USER_DEPARTMENTNAME, departmentname);
    },
    setDepartmenttype(state, departmenttype) {
      state.departmenttype = departmenttype;
      localSave(CURRENT_USER_DEPARTMENTTYPE, departmenttype);
    },
    setDepartmenttypename(state, departmenttypename) {
      state.departmenttypename = departmenttypename;
      localSave(CURRENT_USER_DEPARTMENTTYPENAME, departmenttypename);
    },
  },
  actions: {
    // AuthCenter 统一认证登录
    handleAuthCenterLogin({ commit }, { code, redirectUri }) {
      return new Promise((resolve, reject) => {
        authCallback({ code, redirectUri })
          .then((res) => {
            if (res.data.success && res.data.data && res.data.data[0]) {
              const data = res.data.data[0];
              resetRouter();
              commit('permission/CLEAR_ROUTES');
              commit('setTagNavList', []);
              commit('setToken', data.token);
              commit('setUserId', data.f_id);
              commit('setOrganizename', data.f_organizename);
              commit('setMobilephone', data.f_mobilephone);
              commit('setDepartmentid', data.f_departmentid);
              commit('setDepartmentname', data.f_departmentname);
              commit('setDepartmenttype', data.f_departmenttype);
              commit('setDepartmenttypename', data.f_departmenttypename);
              commit('setUserName', data.f_realname);
              commit('setUserCode', data.f_account);
              commit('setUserRole', data.f_rolename);
              commit('setUserInfo', JSON.stringify(data));
              commit('setAccess', JSON.stringify(data.f_permissioncode));
              resolve(res);
            } else {
              reject(res.data.msg || '登录失败');
            }
          })
          .catch((err) => {
            reject(err.response?.data?.msg || err.message || '登录失败');
          });
      });
    },
    // 手机号+验证码登录
    handlePhoneLogin({ commit }, { phone, code }) {
      return new Promise((resolve, reject) => {
        phoneLogin({ phone: phone.trim(), code: (code || '').trim() })
          .then((res) => {
            if (
              res.data &&
              res.data.success &&
              res.data.data &&
              res.data.data[0]
            ) {
              const data = res.data.data[0];
              resetRouter();
              commit('permission/CLEAR_ROUTES');
              commit('setTagNavList', []);
              commit('setToken', data.token);
              commit('setUserId', data.f_id);
              commit('setOrganizename', data.f_organizename);
              commit('setMobilephone', data.f_mobilephone);
              commit('setDepartmentid', data.f_departmentid);
              commit('setDepartmentname', data.f_departmentname);
              commit('setDepartmenttype', data.f_departmenttype);
              commit('setDepartmenttypename', data.f_departmenttypename);
              commit('setUserName', data.f_realname);
              commit('setUserCode', data.f_account);
              commit('setUserRole', data.f_rolename);
              commit('setUserInfo', JSON.stringify(data));
              commit('setAccess', JSON.stringify(data.f_permissioncode));
              resolve(res);
            } else {
              reject((res.data && res.data.msg) || '登录失败');
            }
          })
          .catch((err) => {
            reject(err.response?.data?.msg || err.message || '登录失败');
          });
      });
    },
    // 登录
    handleLogin({ commit }, { userName, pwd }) {
      const name = userName.trim();
      return new Promise((resolve, reject) => {
        login({ name, pwd })
          .then((res) => {
            if (res.data.success) {
              // if (res.data.data[0].f_departmentid.length === 0) {
              //   alert('该账号没有岗位请联系部门管理员维护!');
              //   return;
              // }
              const data = res.data.data;
              resetRouter();
              commit('permission/CLEAR_ROUTES');
              commit('setTagNavList', []);
              commit('setToken', data[0].token);
              commit('setUserId', data[0].f_id);
              commit('setOrganizename', data[0].f_organizename);
              commit('setMobilephone', data[0].f_mobilephone);
              commit('setDepartmentid', data[0].f_departmentid);
              commit('setDepartmentname', data[0].f_departmentname);
              commit('setDepartmenttype', data[0].f_departmenttype);
              commit('setDepartmenttypename', data[0].f_departmenttypename);
              commit('setUserName', data[0].f_realname);
              commit('setUserCode', data[0].f_account);
              commit('setUserRole', data[0].f_rolename);
              commit('setUserInfo', JSON.stringify(data[0]));
              commit('setAccess', JSON.stringify(data[0].f_permissioncode));
              resolve(res);
            } else {
              reject(res.data.msg);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 退出
    handleLogOut({ commit }) {
      return new Promise((resolve) => {
        commit('setToken', null);
        commit('setTagNavList', []);
        commit('setAccess', []);
        commit('permission/CLEAR_ROUTES');
        localStorage.clear();
        sessionStorage.clear();
        resetRouter();
        resolve();
      });
    },
  },
};
